import actionTypes from '../constants/action-types';

const registerExtension = (extension) => ({
  type: actionTypes.REGISTER_EXTENSION,
  payload: {
    extension,
  },
});

export default registerExtension;
